


import TiwiMixin from '../mixins/TiwiMixin';

export default {
  mixins: [TiwiMixin],
  props: {
    onSubmit: {
      required: true,
      type: Function,
    },
    postId: {
      required: true,
      type: Number,
    },
    replyTo: {
      required: false,
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      current_comment: '',
    }
  },
  mounted: function () {
    this.textarea = this.$refs['textarea'];
  },
  methods: {
    resize() {
      this.textarea.style.height = this.textarea.scrollHeight + 'px';
    },
    submitComment: function () {

      var self = this;
      self.setLoading(true);

      var post_data = {
        content: this.current_comment,
        parent: this.replyTo ? (this.replyTo.parent == 0 ? this.replyTo.ID : this.replyTo.parent) : null, // Id commento padre
        related_id: this.postId,
      };

      this.api.post('comment/submit', post_data)
        .then((response) => {
          if (response.data.success) {
            this.textarea.value = '';
            this.onSubmit(response);
            self.toast.success('Commento inserito correttamente!');
          }
          else {
            self.toast.error(response.data.message);
          }
        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))
    }
  },
  computed: {
    submitDisabled: function () {
      return this.current_comment.length < 3;
    }
  }
}
